// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*purgecss start ignore*/\n:root{\n  --header-height-sm:80px;\n  --header-height:96px\n}\n.slider.slider-reviews .slick-track{\n  display:flex\n}\n.slider.slider-reviews .slick-slide{\n  float:none;\n  margin-left:0.5rem;\n  margin-right:0.5rem;\n  height:auto;\n  min-height:0px;\n  opacity:1\n}\n.slider.slider-reviews .slick-slide>div{\n  height:100%\n}\n\n/*purgecss end ignore*/", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
